module.exports = __webpack_public_path__ + "static/img/8.c9628b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/8.png
// module id = gu8K
// module chunks = 0